import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import '../../Styles/EmailVerify.scss'
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import { CircularProgress } from "@material-ui/core";

export default class EmailVerification extends Component {  
  constructor(props) {
    debugger;
    super(props);
}
componentDidMount(){
  this.getValidEmail();
}
async getValidEmail() {
  debugger;
  try {
    this.setState({ ...this.state, loader: true });
    let params = {
      salt: this.props.match.params.salt,
      tenantKey: this.props.match.params.id,
    };
    this.setState({ ...this.state, loader: true });
    let response = await Api.emailVerification(params);
    if (response.status === 200) {
      this.setState({ ...this.state, loader: false });
      this.setState({ impactslist: response.impact });
    }
    else
    {
      window.location.href = "https://riskwellweb.azurewebsites.net/user/"+params.tenantKey
    }
  } catch (error) {
    this.setState({ ...this.state, loader: false });
    console.error(error);
  }
};
  render() {
    let tenantKey = secureLocalStorage.getItem("tenantKey");
    return (
      <div className=" emailVerifyCont">
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <img src={Images.RISKWELLLOGO} width="140" />
        <span><img src={Images.CHECKGREEN} width="50"/></span>
        <h2>Thank You!</h2>
        <p>Your email has been successfully verified.</p>
      </div>
    );
  }
}
